import { useEffect } from 'react';
import { IoShareOutline } from 'react-icons/io5';
import { ActionsIcon } from '../../assets/svg/actions';
import { isMobile } from '../../helpers/devices';
import { useLang } from '../../hooks/use-lang';
import { useAlertStore } from '../../store/use-alert-store';

const isPwaInstalled = async () => {
  if ('getInstalledRelatedApps' in window.navigator) {
    // @ts-ignore
    const relatedApps = await navigator.getInstalledRelatedApps();
    // @ts-ignore
    return relatedApps.some((app) => app.platform === 'webapp' && app.url === window.location.href);
  }
  return false;
};

const isPWA = () =>
  //@ts-ignore
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

const isIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent) && !/crios/.test(userAgent);
};

export const usePWAInstall = () => {
  const { add } = useAlertStore();
  const { t } = useLang();

  useEffect(() => {
    if (!isMobile() || isPWA()) return;

    isPwaInstalled().then((installed) => {
      if (installed) {
        add({
          label: t('Приложение установлено'),
          variant: 'success',
          endless: true,
        });
        return;
      }
      if (isIOS()) {
        add({
          label: t('Установите приложение'),
          variant: 'info',
          endless: true,
          children: (
            <ul>
              <li>
                1. <IoShareOutline />
                {t('Поделиться')}
              </li>
              <li>2. {t('На экран Домой')}</li>
            </ul>
          ),
        });
      } else {
        add({
          label: t('Установите приложение'),
          variant: 'info',
          endless: true,
          children: (
            <ul>
              <li>
                1. <ActionsIcon style={{ transform: 'rotate(90deg)', height: 16 }} />
                {t('В правом верхнем углу')}
              </li>
              <li>2. {t('Добавить на главный экран')}</li>
              <li>3. {t('Установить')}</li>
            </ul>
          ),
        });
      }
    });
  }, []);
};
